import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    slider: {
        "&.MuiSlider-root.Mui-disabled": {
            color: theme.palette.primary.main
        }
    }
}))